import {useContext, useEffect, useRef, useState} from 'react'
import {Draggable} from 'react-beautiful-dnd'
import {Badge, Button} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import Select from 'react-select'
import {KTIcon} from '../../../../../_metronic/helpers'
import {showMessage} from '../../../../shared/Alerts'
import {SheetEditContext} from '../SheetContexts'

// Variable global para la posición del mouse
let mousePosition = {x: 0, y: 0}

// Actualizar la posición del mouse globalmente
document.addEventListener('mousemove', (e) => {
  mousePosition = {x: e.clientX, y: e.clientY}
})

const grid = 8

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // Some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // Change background color if dragging
  background: isDragging ? '#18c073' : 'white',
  borderRadius: 10,
  // Styles we need to apply on draggables
  ...draggableStyle,
})

const CollapsibleFieldItem = ({item, index, sectionItem, permisos}: any) => {
  const [showMenu, setShowMenu] = useState(false)
  const buttonRef = useRef<HTMLAnchorElement>(null)

  const {
    openFieldModal,
    openDocumentModal,
    setData,
    sheetData,
    setFieldData,
    setFieldDocumentData,
    setSectionData,
    openAssignmentModal,
    openAssignmentRequeridoModal,
    openEntityModal,
  } = useContext(SheetEditContext)

  const deleteField = () => {
    if(sheetData.type == "firma"){
      setData({
        ...sheetData,
        sections: sheetData?.sections?.map((n) =>
          n.id === sectionItem.id ? {...n, fieldsDocument: n.fieldsDocument?.filter((f) => f.id !== item.id)} : n
        ),
      })
    }else{
      setData({
        ...sheetData,
        sections: sheetData?.sections?.map((n) =>
          n.id === sectionItem.id ? {...n, fields: n.fields?.filter((f) => f.id !== item.id)} : n
        ),
      })
    }
    
  }

  const editField = () => {
    setSectionData(sectionItem)
    setFieldData(item)
    openFieldModal()
  }

  const editFieldDocument = () => {
    setSectionData(sectionItem)
    setFieldDocumentData(item)
    openDocumentModal()
  }

  const addAssignment = () => {
    setSectionData(sectionItem)
    setFieldData(item)
    openAssignmentModal()
  }

  const addAssignmentRequerido = () => {
    setSectionData(sectionItem)
    setFieldData(item)
    openAssignmentRequeridoModal()
  }

  const handleButtonClick = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      mousePosition = {
        x: rect.right + window.scrollX + 5, // Añadimos window.scrollX para la posición absoluta
        y: rect.top + window.scrollY, // Añadimos window.scrollY para la posición absoluta
      }
    }
    setShowMenu(!showMenu)
  }

  const handleMoveToSection = (targetSectionId: string) => {
    // Encontrar la sección destino
    const targetSection = sheetData.sections?.find((section) => section.id === targetSectionId)

    // Verificar si ya existe un campo con el mismo nombre en la sección destino
    const fieldExists = targetSection?.fields?.some((field) => field.name === item.name)

    if (fieldExists) {
      // Aquí puedes usar tu sistema de alertas o notificaciones
      showMessage(
        'error',
        'Error',
        `Ya existe un campo con el nombre "${item.name}" en la sección "${targetSection?.name}"`
      )
      return
    }

    const updatedSections = sheetData.sections?.map((section) => {
      if (section.id === sectionItem.id) {
        return {
          ...section,
          fields: section.fields?.filter((field) => field.id !== item.id),
        }
      }
      if (section.id === targetSectionId) {
        return {
          ...section,
          fields: [...(section.fields || []), item],
        }
      }
      return section
    })

    setData({
      ...sheetData,
      sections: updatedSections,
    })
    setShowMenu(false)
  }

  const options =
    sheetData.sections
      ?.filter((section) => section.id !== sectionItem.id)
      .map((section) => ({
        value: section.id,
        label: section.name,
      })) || []

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
        >
          {
            sheetData.type === "firma"?
              <div style={{position: 'relative'}}>
                <div style={{marginLeft: '30px', fontWeight: 'normal'}}>{item.titulo}</div>
                <div
                  style={{marginLeft: '500px', fontWeight: 'normal', position: 'absolute', top: '0'}}
                >
                  | {item.tipo.label}
                </div>

                <div {...provided.dragHandleProps} style={{position: 'absolute', top: '0', left: '0'}}>
                  <Badge
                    bg='gray-600'
                    className='me-2'
                    style={{transform: 'translateY(-2px)', color: 'white'}}
                  >
                    {index + 1}
                  </Badge>
                </div>

                <div style={{position: 'absolute', top: '0', right: '0', display: 'flex', gap: '10px'}}>

                  <a
                    href='#!'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    style={{transform: 'translateY(-8px)'}}
                    title='Editar Campo'
                    onClick={() => editFieldDocument()}
                  >
                    <KTIcon iconName='pencil' className='fs-3' />
                  </a>
                  <a
                    href='#!'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    style={{transform: 'translateY(-8px)'}}
                    title='Eliminar Campo'
                    onClick={() => deleteField()}
                  >
                    <KTIcon iconName='trash' className='fs-3' />
                  </a>
                </div>
              </div>
            :
              <div style={{position: 'relative'}}>
                <div style={{marginLeft: '30px', fontWeight: 'normal'}}>{item.name}</div>
                <div
                  style={{marginLeft: '500px', fontWeight: 'normal', position: 'absolute', top: '0'}}
                >
                  | {item.type[0].nombre}
                </div>

                <div {...provided.dragHandleProps} style={{position: 'absolute', top: '0', left: '0'}}>
                  <Badge
                    bg='gray-600'
                    className='me-2'
                    style={{transform: 'translateY(-2px)', color: 'white'}}
                  >
                    {index + 1}
                  </Badge>
                </div>

                <div style={{position: 'absolute', top: '0', right: '0', display: 'flex', gap: '10px'}}>
                  {permisos.includes('Asignacion Requeridas') && (
                    <a
                      href='#!'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      style={{transform: 'translateY(-8px)'}}
                      title='Asignar Datos Requeridos'
                      onClick={() => addAssignmentRequerido()}
                    >
                      <KTIcon iconName='disconnect' className='fs-3' />
                    </a>
                  )}
                  {permisos.includes('Asignacion PowerApps') && (
                    <a
                      href='#!'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      style={{transform: 'translateY(-8px)'}}
                      title='Asignar a Power Apps'
                      onClick={() => addAssignment()}
                    >
                      <KTIcon iconName='disconnect' className='fs-3' />
                    </a>
                  )}

              <Button
                size='sm'
                color='light'
                className='me-1'
                variant='icon'
                style={{transform: 'translateY(-8px)'}}
                title='Asignar a ficha colaborador'
                onClick={() => {
                  setSectionData(sectionItem)
                  setFieldData(item)
                  openEntityModal()
                }}
              >
                <KTIcon iconName='user' className='fs-3' />
              </Button>

                  <a
                    ref={buttonRef}
                    href='#!'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    style={{transform: 'translateY(-8px)'}}
                    title='Mover a otra sección'
                    onClick={handleButtonClick}
                  >
                    <KTIcon iconName='arrow-right-left' className='fs-3' />
                  </a>

                  {showMenu &&
                    createPortal(
                      <div
                        style={{
                          position: 'absolute',
                          top: mousePosition.y,
                          left: mousePosition.x,
                          backgroundColor: 'white',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          minWidth: '250px',
                          padding: '8px',
                          zIndex: 9999,
                        }}
                      >
                        <Select
                          options={options}
                          placeholder='Buscar sección...'
                          autoFocus
                          isSearchable
                          onChange={(option) => option && handleMoveToSection(option.value)}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '38px',
                              border: '1px solid #ddd',
                              boxShadow: 'none',
                              '&:hover': {
                                border: '1px solid #ddd',
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              marginTop: '4px',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            }),
                          }}
                        />
                      </div>,
                      document.body
                    )}

                  <a
                    href='#!'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    style={{transform: 'translateY(-8px)'}}
                    title='Editar Campo'
                    onClick={() => editField()}
                  >
                    <KTIcon iconName='pencil' className='fs-3' />
                  </a>
                  <a
                    href='#!'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    style={{transform: 'translateY(-8px)'}}
                    title='Eliminar Campo'
                    onClick={() => deleteField()}
                  >
                    <KTIcon iconName='trash' className='fs-3' />
                  </a>
                </div>
              </div>
          }
        </div>
      )}
    </Draggable>
  )
}

export {CollapsibleFieldItem}
